module.exports = __webpack_public_path__ + "img/react.47ce6e77.png";